export default __webpack_public_path__ + "static/vacations-preview-cruise-1-0397dfe70c059f64984449259aca20ef.jpg";